import { FC } from "react";

const Error404: FC = () => {
  return (
    <>
      <div className="mt-6 text-[56px] font-bold leading-none text-[#2196f3]">
        404
      </div>
      <h1 className="mt-3 text-2xl font-semibold text-slate-900">
        Pagina nu a fost găsită
      </h1>
      <p className="mt-3 text-sm leading-6 text-muted-dark">
        Adresa accesată nu există sau pagina a fost mutată.
      </p>
    </>
  );
};

export { Error404 };
